module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/CoverSection/fire-6e87d57ec62cb11b9a353a5412a35cd7.png";